
export default function () {
    return{
        data() {
            return {
                apipostOptions: [], // 用于存储异步加载的数据
                loadingOptions: false, // 加载状态
                lastApipostParams: null, // 记录上次加载参数
            }
        },
        computed:{
            dataCode(){
                return this.data.dataCode
            },
            dataType(){
                return this.data.dataType
            },
            dataUpCtrl(){
                if(this.data.upCtrl && (this.formData || this.upformData)){
                    var formData = undefined;
                    if(this.formData && this.formData.hasOwnProperty(this.data.upCtrl))
                        formData = this.formData;
                    else if(this.upformData && this.upformData.hasOwnProperty(this.data.upCtrl))
                        formData = this.upformData;
                    if (formData) { 
                        return formData[this.data.upCtrl]
                    }
                }
                return null;
            },
            myOptions(){
                // 1 静态数据 2 数据字典 3 远端数据(数据源)
                switch(this.dataType){
                    case '1':
                        return this.data.options
                    case '2':
                        if(this.lr_dataItem && this.dataCode){
                            if(this.data.type == 'treeselect'){
                                return this.lr_dataItemTree(this.lr_dataItem[this.dataCode])
                            }
                            else{
                                return this.lr_dataItemOptions(this.lr_dataItem[this.dataCode])
                            }
                        }
                        else{
                            return []
                        }
                    case '3':
                        
                        if(this.lr_dataSourceData && this.dataCode && this.data.dataValueKey && this.data.dataLabelKey){
                            let dataSource = []
                            
                            if (this.data.upCtrl) {
                                /*console.log(this.data, this.formData)
                                if(this.formData && this.formData[this.data.upCtrl]){
                                    const upCtrlVal = this.formData[this.data.upCtrl]
                                    
                                    const upCtrlValList = upCtrlVal.split(',') // 考虑数据多选的问题
                                    console.log(upCtrlValList)
                                    upCtrlValList.forEach( v =>{
                                        this.lr_loadDataSourceDataByParamter(this.dataCode, v)//解决编辑赋值没有触发问题
                                        const vList = this.lr_dataSourceDataByParamter[`${this.dataCode}_${v}`] || []
                                        dataSource.push(...vList.filter(t=>!dataSource.some(t2 => t2[this.data.dataValueKey] === t[this.data.dataValueKey])))
                                    })
                                }*/
                                const upCtrlVal = this.dataUpCtrl;
                                if(upCtrlVal){
                                    const upCtrlValList = upCtrlVal.split(',') // 考虑数据多选的问题
                                   // console.log(upCtrlValList)
                                    upCtrlValList.forEach( v =>{
                                        this.lr_loadDataSourceDataByParamter(this.dataCode, v)//解决编辑赋值没有触发问题
                                        const vList = this.lr_dataSourceDataByParamter[`${this.dataCode}_${v}`] || []
                                        dataSource.push(...vList.filter(t=>!dataSource.some(t2 => t2[this.data.dataValueKey] === t[this.data.dataValueKey])))
                                    })
                                }
                            }
                            else{
                                dataSource = this.lr_dataSourceData[this.dataCode]
                            }


                            if(this.data.type == 'treeselect'){
                                if(this.data.dataIdKey && this.data.dataPIdKey){
                                    return this.lr_DataSourceTree(dataSource,this.data.dataIdKey,this.data.dataPIdKey,this.data.dataValueKey,this.data.dataLabelKey)
                                }
                                else{
                                    return []
                                }
                            }
                            else{
                                return this.lr_DataSourceOptions(dataSource,this.data.dataValueKey,this.data.dataLabelKey)
                            }
                        }
                        else{
                            return []
                        }
                    case '4':
                        break;
                    case '5':
                        return this.loadingOptions ? [] : this.apipostOptions
                    default:
                        return []
                }
            },
            myColNameList(){
                if(this.lr_dataSourceCol && !this.$validatenull(this.dataCode)){
                    const colNameList = this.lr_dataSourceCol[this.dataCode] || []
                    return colNameList.map(t=>{return {value:t,label:t}})
                }
                else{
                    return []
                }
                
            },
            componentOptions() {
                const res = []
                if (this.formDesign) {
                    const formInfo = this.formDesign.toSaveData()
                    if(!this.data.subfield && formInfo.tabList){
                        formInfo.tabList.forEach((tab) => {
                            tab.components.forEach((com) => {
                                if (["checkbox","radio","select","selectMultiple","treeselect","layerselect",'companySelect','departmentSelect','userSelect','tenantcompanyid'].includes(com.type) && com.prop != this.data.prop) {
                                    res.push({ value: com.prop, label: com.label, field: com.field })
                                }
                            })
                        })
                    }
                    if(this.data.subfield && formInfo.tabList){
                        formInfo.tabList.forEach(tab=>{
                            tab.components.forEach(com=>{
                                if(['gridtable'].includes(com.type) && com.children.findIndex(t=>t.prop == this.data.prop) != -1 ){
                                    com.children.forEach(c=>{
                                        if(["checkbox","radio","select","selectMultiple","treeselect","layerselect",'companySelect','departmentSelect','userSelect','tenantcompanyid'].includes(c.type) && c.prop != this.data.prop && c.prop != this.data.prop ){
                                            res.push({value:c.prop,label:c.label, field: c.field})
                                        }
                                    })
                                }
                            })
                        })
                    }
                }
                return res
            }
        },
        watch: {
            dataUpCtrl(newVal, oldVal) {
                if (this.data.dataType === '5' && newVal !== oldVal) {
                    this.loadApipostData();
                }
            }
        },
        created(){
            this.loadOptions()
        },
        methods: {
            loadOptions(){
                var isCache = !this.data.notUseCache;
                if(this.dataType == '2' && this.lr_loadDataItem && this.dataCode){
                    this.lr_loadDataItem(this.dataCode)
                }
                else if(this.dataType == '3' && this.lr_loadDataSourceData && this.dataCode){
                    if (this.data.upCtrl) {  //add by torres 20210813
                        //新写 用this.formData 获取upCtrl的值
                        /*var formData = undefined;
                        if(this.formData && this.formData.hasOwnProperty(this.data.upCtrl))
                            formData = this.formData;
                        else if(this.upformData && this.upformData.hasOwnProperty(this.data.upCtrl))
                            formData = this.upformData;
                        console.log(formData)
                        if (formData) { 
                            const upCtrlVal = formData[this.data.upCtrl]
                            this.lr_loadDataSourceDataByParamter(this.dataCode, upCtrlVal, isCache)
                        }*/
                        this.lr_loadDataSourceDataByParamter(this.dataCode, this.dataUpCtrl, isCache)
                    }
                    else {
                        this.lr_loadDataSourceData(this.dataCode, isCache)
                    }
                }
                else if(this.dataType == '4' ){

                }
                else if(this.dataType == '5' && this.lr_loadApipostData && this.dataCode ){
                    this.lr_loadApipostData(this.dataCode, this.dataUpCtrl, isCache)
                }
            },
            async loadApipostData() {
                if(this.loadingOptions == true)
                    return;
                try {            
                    this.loadingOptions = true        
                    if (this.dataCode && this.data.dataValueKey && this.data.dataLabelKey) {
                        let isCache = !this.data.notUseCache                    
                        if (this.data.upCtrl && this.data.upCtrlField) {
                            const upCtrlVal = this.dataUpCtrl;
                                if(upCtrlVal){
                                    var Parameters = {}                               
                                    Parameters[this.data.upCtrlField] = this.dataUpCtrl     
                                    var lastApipostParams = JSON.stringify(Parameters)    
                                    if(this.lastApipostParams != lastApipostParams)   {
                                        isCache = false
                                        this.lastApipostParams = lastApipostParams
                                    }                        
                                }
                        }
                        console.log(this.lastApipostParams)
                        let dataSource = await this.lr_loadApipostData(this.dataCode, this.lastApipostParams, isCache)
                        if(this.data.type == 'treeselect'){
                            if(this.data.dataIdKey && this.data.dataPIdKey){
                                this.apipostOptions = this.lr_apipostTree(dataSource,this.data.dataIdKey,this.data.dataPIdKey,this.data.dataValueKey,this.data.dataLabelKey) || []
                            }
                            else{
                                this.apipostOptions = []
                            }
                        }
                        else{
                            this.apipostOptions = dataSource.map(t=>{ return {...t,label:t[this.data.dataLabelKey],value:t[this.data.dataValueKey]}})
                        }
                    }
                } catch (error) {
                    console.error('加载 apipost 数据失败:', error)
                    this.apipostOptions = []
                } finally {
                    this.loadingOptions = false
                }
            },
            loadDataSourceCol(){
                if(this.dataType == '3' && this.lr_loadDataSourceData && !this.$validatenull(this.dataCode)){
                    this.lr_loadDataSourceColNames(this.dataCode)
                }
            },
            getComponent (type) {
                let result = 'el-input';
                switch(type){
                    case 'btns':
                        result = 'l-buttons'
                        break;
                    case 'divider':
                        result = 'el-divider'
                        break
                    case 'input':
                    case 'textarea':
                    case 'password':
                        result = 'el-input'
                        break
                    case 'linkable':
                        result='l-linkable'
                        break;
                    case 'carnumber':
                        result='l-car-number'
                        break;
                    case 'image':
                    case 'headIcon':
                    case 'workImage':
                    case 'signature':
                    case 'stamp':
                        result='el-image'
                        break;
                    case 'number':
                        result = 'el-input-number'
                        break
                    case 'radio':
                        result = 'l-radio'
                        break
                    case 'checkbox':
                        result = 'l-checkbox'
                        break
                    case 'select':
                    case 'selectMultiple':
                        result = 'l-select'
                        break
                    case 'cascader':
                        result =  'el-cascader'
                        break
                    case 'treeselect':
                        result =  'l-tree-select'
                        break
                    case 'time':
                        result = 'l-time'
                        break
                    case 'timerange':
                        result = 'l-time'
                        break
                    case 'datetime':
                        result = 'l-date'
                        break
                    case 'datetimerange':
                        result = 'l-date'
                        break
                    case 'upload':
                        result = 'l-upload'
                        break
                    case 'uploadimg':
                        result = 'l-upload'
                        break
                        case 'uploadmodel':
                            result = 'l-uploadmodel'
                            break;
                    case 'guid':
                        result = 'l-guid'
                        break
                    case 'companySelect':
                        result = 'l-company-select'
                        break
                    case 'departmentSelect':
                        result = 'l-department-select'
                        break
                    case 'userSelect':
                        result = 'l-user-select'
                        break
                    case 'company':
                        result = 'l-company'
                        break
                    case 'department':
                        result = 'l-department'
                        break
                    case 'createuser':
                        result = 'l-createuser'
                        break
                    case 'modifyuser':
                        result = 'l-modifyuser'
                        break
                    case 'createtime':
                        result = 'l-createtime'
                        break
                    case 'modifytime':
                        result = 'l-modifytime'
                        break
                    case 'encode':
                        result = 'l-code'
                        break
                    case 'icon':
                        result ='l-input-icon'
                        break
                    case 'rate':
                        result ='el-rate'
                        break
                    case 'switch':
                        result ='el-switch'
                        break
                    case 'slider':
                        result ='el-slider'
                        break
                    case 'color':
                        result ='l-input-color'
                        break
                    case 'areaselect':
                        result ='l-area-select'
                        break
                    case 'layerselect':
                        result ='l-layer-select'
                        break
                    case 'layerbmap':
                        result = 'l-BMap-select'
                        break
                    case 'tenantid':
                        result = 'l-tenantid'
                        break
                    case 'tenantname':
                        result = 'l-tenantname'
                        break
                    case 'tenantno':
                        result = 'l-tenantno'
                        break
                    case 'tenantcompany':
                        result = 'l-tenantcompany'
                        break
                    case 'tenantcompanyid':
                        result = 'l-tenantcompanyid'
                        break
                }
                return result;
            }
        }
    }
}